export default "__VITE_ASSET__MV7nYnq2__"